

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { GlobalVariables } from "../../components/GlobalVariablesSetup/GlobalVariablesSetup";


export const GlobalVariablesPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Cheque Settings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Global Variables", navigateTo: "/settings/cheque/list" },
      ]}
      mainContents={<GlobalVariables />}
    />
  );
};
